const calculaAgrupacioConceptes = (agregatConceptes) => {
    const mapAgrupacio = {};
    for (const concepte in agregatConceptes) {
        const item = agregatConceptes[concepte];
        const key = item.concepte.agrupacio;

        let agrupacio = mapAgrupacio[key];
        if( agrupacio === undefined) {
        agrupacio = {
            agrupacio: key,
            tipus: item.concepte.tipus,
            saldo: 0
        };
        mapAgrupacio[key] = agrupacio;
        }

        agrupacio.saldo = agrupacio.saldo + item.importAgregat.saldo;
    }

    return mapAgrupacio;
    };

    export { calculaAgrupacioConceptes };